module.exports = __webpack_public_path__ + "img/breakdown.4719ec23.png";